import React, {
  useCallback, useEffect, useRef, memo,
} from 'react';
import Swiper from 'swiper';
import PropTypes from 'prop-types';
import ReviewSliderSlide from './ReviewSliderSlide';
import {mediaSizes} from '../../../configs/media';
import 'swiper/dist/css/swiper.min.css';
import './ReviewSlider.less';

function ReviewSlider({reviews, language}) {
  const swiperRef = useRef();
  const revieSwiperContainer = useRef();
  const prevRef = useRef();
  const nextRef = useRef();

  const initSwiper = useCallback(() => {
    swiperRef.current = new Swiper(revieSwiperContainer.current, {
      fade: {crossFade: true},
      virtualTranslate: true,
      loop: true,
      effect: 'fade',
      autoHeight: false,
      centeredSlides: true,
      allowSlidePrev: false,
      slidesPerView: 1,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: null,
        nextEl: null,
      },
      breakpoints: {
        [mediaSizes.lg]: {
          allowSlidePrev: true,
        },
      },
    });
  }, []);

  useEffect(() => {
    if (reviews.length > 1) {
      initSwiper();
    }
    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
      }
    };
  }, [reviews]);

  return (
    <div className="review-swiper">
      <div className="swiper-container review-swiper-container" ref={revieSwiperContainer}>
        <div className="swiper-wrapper">
          {reviews.map((review) => (
            <ReviewSliderSlide
              key={review._id}
              review={review}
              language={language}
            />
          ))}
        </div>
      </div>
      <div className="block-txt-arrow">
        <span className="block-txt-arrow-item review-swiper-prev left" ref={prevRef}>
          <i className="fa fa-angle-left" aria-hidden="true" />
        </span>
        <span className="block-txt-arrow-item review-swiper-next right" ref={nextRef}>
          <i className="fa fa-angle-right" aria-hidden="true" />
        </span>
      </div>
    </div>
  );
}

ReviewSlider.defaultProps = {
  reviews: [],
  language: 'ru',
};

ReviewSlider.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  language: PropTypes.string,
};

export default memo(ReviewSlider);
